<template>
  <v-dialog v-model="dialog" width="800" scrollable persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        :outlined="!$vuetify.breakpoint.xs"
        color="danger"
        v-bind="attrs"
        v-on="on"
      >
        {{
          $vuetify.breakpoint.xs
            ? ""
            : $vuetify.breakpoint.mobile
            ? "Meldung"
            : "Meldung häufiger Absenzen"
        }}
      </v-btn>
    </template>

    <v-card :loading="loading">
      <v-system-bar color="danger">Meldung häufiger Absenzen</v-system-bar>
      <div class="d-flex">
        <PersonItem :value="item.student"></PersonItem
        ><PersonItem :value="item.teacher"></PersonItem>
      </div>
      <v-card-text class="pa-0">
        <v-list class="m0 red lighten-5">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="text-wrap">
                Stand bei Meldung:</v-list-item-subtitle
              >

              <v-chip-group column>
                <v-chip color="error" outlined
                  >offen: {{ item.pendingCount }}</v-chip
                >

                <v-chip color="success" outlined
                  >entschuldigt: {{ item.excusedCount }}</v-chip
                >

                <v-chip color="danger" outlined
                  >unentschuldigt: {{ item.unexcusedCount }}</v-chip
                >
                <v-chip color="primary" outlined
                  >total:
                  {{
                    item.pendingCount + item.excusedCount + item.unexcusedCount
                  }}</v-chip
                >
              </v-chip-group>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="absences">
            <v-list-item-content>
              <v-list-item-subtitle class="text-wrap">
                Aktueller Stand:</v-list-item-subtitle
              >

              <v-chip-group column>
                <v-chip color="error" outlined
                  >offen: {{ absences.pendingLessons }}</v-chip
                >

                <v-chip color="success" outlined
                  >entschuldigt: {{ absences.excusedLessons }}</v-chip
                >

                <v-chip color="danger" outlined
                  >unentschuldigt: {{ absences.unexcusedLessons }}</v-chip
                >
                <v-chip color="primary" outlined
                  >total:
                  {{
                    absences.pendingLessons +
                    absences.excusedLessons +
                    absences.unexcusedLessons
                  }}</v-chip
                >
              </v-chip-group>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-checkbox
              v-model="item.repeatedViolation"
              @change="changed = true"
              label="Es sind wiederholt Verstösse gegen die Absenzenordnung
              aufgetreten."
            ></v-checkbox>
          </v-list-item>

          <v-list-item>
            <v-checkbox
              v-model="item.sumExceeds"
              @change="changed = true"
              label="Die Summe der gesamten Absenzen im Semester überschreitet ein Wochenpensum."
            ></v-checkbox>
          </v-list-item>

          <v-list-item>
            ¨
            <v-textarea
              label="Datum des Elterngesprächs / Gesprächsnotiz"
              v-model="item.meetingTeacher"
              outlined
              @change="changed = true"
              rows="5"
            ></v-textarea>
          </v-list-item>

          <v-list-item>
            <v-textarea
              label="Von der Klassenlehrkraft gemäss Absenzenordnung bereits
                getroffene Massnahmen"
              v-model="item.measures"
              outlined
              @change="changed = true"
              rows="5"
            ></v-textarea>
          </v-list-item>

          <v-list-item>
            <v-checkbox
              v-model="item.parentsInformed"
              @change="changed = true"
              label="Eine Rücksprache mit den Eltern (gem. Art. 131 Abs. 5 MiSDV) ist
                erfolgt."
            ></v-checkbox>
          </v-list-item>

          <v-list-item>
            <v-textarea
              label="Antrag der Klassenlehrkraft"
              :hint="'z.B.: ' + this.resolutions.join(', ')"
              v-model="item.application"
              outlined
              persistent-hint
              @change="changed = true"
              rows="5"
            ></v-textarea>
          </v-list-item>
        </v-list>
        <v-divider class="mb-4"></v-divider>
        <v-list class="green lighten-5">
          <v-list-item>
            <v-combobox
              :items="resolutions"
              label="Beschluss Abteilungsleitung"
              outlined
              v-model="item.resolution"
              @change="changed = true"
            ></v-combobox>
          </v-list-item>
          <v-list-item>
            <v-textarea
              label="Ausführungen zum Beschluss"
              v-model="item.decision"
              @change="changed = true"
              outlined
              rows="5"
            ></v-textarea>
          </v-list-item>
          <v-list-item>
            <v-textarea
              label="weitere Bemerkungen"
              v-model="item.meetingCommittee"
              outlined
              @change="changed = true"
              rows="5"
            ></v-textarea>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-checkbox
                v-model="item.emailSent"
                @change="changed = true"
                label="E-Mail wurde versandt."
              ></v-checkbox>
            </v-list-item-content>
            <v-list-item-action>
              <FrequentAbsencesMail
                :item="item"
                :absences="absences"
              ></FrequentAbsencesMail>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn text @click="close">abbrechen </v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="saving" color="primary" text @click="save"
          >speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import PersonItem from "common/components/PersonItem.vue";
import FrequentAbsencesMail from "./FrequentAbsencesMail.vue";

import resolutions from "common/components/Absences/frequentAbsencesResolutions.js";

export default defineComponent({
  components: { PersonItem, FrequentAbsencesMail },
  props: ["frequentAbsencesId", "personId", "termId"],
  data() {
    return {
      dialog: true,
      loading: false,
      item: {},
      saving: false,
      changed: false,
      absences: {},
      resolutions,
    };
  },
  watch: {
    frequentAbsencesId() {
      this.fetchData();
    },
    dialog(val) {
      if (!val) {
        this.$router.back();
      }
    },
    async termId() {
      this.absences = await this.apiGet({
        resource: "absence/overview",
        id: this.personId,
        query: `term=${this.termId}`,
      });
    },
  },

  methods: {
    async fetchData() {
      if (!this.frequentAbsencesId) {
        this.item = {};
        return;
      }
      this.loading = true;

      this.item = await this.apiGet({
        resource: "absence/frequentAbsences",
        id: this.frequentAbsencesId,
      });
      if (this.termId) {
        this.absences = await this.apiGet({
          resource: "absence/overview",
          id: this.personId,
          query: `term=${this.termId}`,
        });
      }
      this.changed = false;
      this.loading = false;
    },
    async save() {
      this.saving = true;
      await this.apiPut({
        resource: "absence/frequentAbsences",
        id: this.item.id,
        data: this.item,
      });
      this.$emit("saved");
      this.$root.showSuccess("Erfolgreich gespeichert");
      this.saving = false;
      this.dialog = false;
    },
    async close() {
      if (this.changed) {
        if (
          await this.$root.confirm({
            message: `Es wurden Änderungen vorgenommen, die nicht gespeichert wurden. Wollen Sie wirklich abbrechen?`,
            color: "danger",
            icon: "mdi-alert",
          })
        ) {
          this.dialog = false;
          return;
        }
        return;
      }
      this.dialog = false;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
